import _ from 'lodash'
export const getLastResume = (userDetails) => {
    if (!userDetails?.resumeFiles?.length) return;
    
    return _.last(userDetails?.resumeFiles, item => !!item.isPrimary);
}